module.exports = __webpack_public_path__ + "img/011.0e868eb3.jpg";